// export const api_URL = "http://localhost:8498/api/"; // Local development URL

export const api_URL = "https://portail.ipmccv.com//office/api/";

export const api_DisplayName = new URL(api_URL).hostname.split('.')[0];
export const SECRET_KEY = "mmskoijdiedt356sjygs@jhushllpllplfcfrft"